// "use client"
//
// import { Input } from "@/components/ui/input"
// import {
// 	Select,
// 	SelectContent,
// 	SelectItem,
// 	SelectTrigger,
// 	SelectValue
// } from "@/components/ui/select"
// import { Card } from "@/components/ui/card"
// import { Checkbox } from "@/components/ui/checkbox"
// import { useFormContext } from "react-hook-form"
// import {
// 	FormControl,
// 	FormField,
// 	FormItem,
// 	FormLabel,
// 	FormMessage
// } from "@/components/ui/form"
// import {
// 	birthConditions,
// 	breedingTypes,
// 	paternalTypes,
// 	ratios,
// 	vaccineArray
// } from "@/utils/items.ts"
//
//
// export function GeneticInfoForm () {
// 	const { control, setValue, watch } = useFormContext ()
// 	const currentVaccinations = watch ( "vaccination" ) || []
//
// 	const handleVaccinationChange = ( value : string ) => {
// 		if ( currentVaccinations.includes ( value ) ) {
// 			setValue (
// 					"vaccination",
// 					currentVaccinations.filter ( ( v : string ) => v !== value ),
// 			)
// 		} else {
// 			setValue ( "vaccination", [ ...currentVaccinations, value ] )
// 		}
// 	}
//
// 	return (
// 			<div className="space-y-6" >
// 				<h2 className="text-2xl font-bold text-center mb-6" >Genetic
// 				                                                     Information</h2 >
//
// 				<div className="grid grid-cols-1 md:grid-cols-2 gap-6" >
// 					<FormField
// 							control={ control }
// 							name="paternalNucleus"
// 							render={ ( { field } ) => (
// 									<FormItem >
// 										<FormLabel >Paternal Nucleus</FormLabel >
// 										<FormControl >
// 											<Input
// 													placeholder="Enter paternal nucleus" { ...field } />
// 										</FormControl >
// 										<FormMessage />
// 									</FormItem >
// 							) }
// 					/>
//
// 					<FormField
// 							control={ control }
// 							name="paternalType"
// 							render={ ( { field } ) => (
// 									<FormItem >
// 										<FormLabel >Paternal Type</FormLabel >
// 										<Select onValueChange={ field.onChange }
// 										        defaultValue={ field.value } >
// 											<FormControl >
// 												<SelectTrigger >
// 													<SelectValue
// 															placeholder="Select paternal type" />
// 												</SelectTrigger >
// 											</FormControl >
// 											<SelectContent
// 													className={ 'overflow-y-auto z-50 shadow-lg bg-white' }
// > { paternalTypes.map ( ( option ) => ( <SelectItem key={ option.value } value={
// option.value } > { option.label } </SelectItem > ) ) } </SelectContent > </Select
// > <FormMessage /> </FormItem > ) } />  <FormField control={ control }
// name="breedingType" render={ ( { field } ) => ( <FormItem > <FormLabel >Breeding
// Type</FormLabel > <Select onValueChange={ field.onChange } defaultValue={
// field.value } > <FormControl > <SelectTrigger > <SelectValue placeholder="Select
// breeding type" /> </SelectTrigger > </FormControl > <SelectContent className={
// 'overflow-y-auto z-50 shadow-lg bg-white' } > { breedingTypes.map ( ( option ) =>
// ( <SelectItem key={ option.name } value={ option.name } > { option.label }
// </SelectItem > ) ) } </SelectContent > </Select > <FormMessage /> </FormItem > )
// } />  <FormField control={ control } name="racialComposition" render={ ( { field
// } ) => ( <FormItem > <FormLabel >Racial Composition</FormLabel > <Select
// onValueChange={ field.onChange } defaultValue={ field.value } > <FormControl >
// <SelectTrigger > <SelectValue placeholder="Select racial composition" />
// </SelectTrigger > </FormControl > <SelectContent className={ 'overflow-y-auto
// z-50 shadow-lg bg-white' } > { ratios.map ( ( option ) => ( <SelectItem key={
// option.value } value={ option.value } > { option.label } </SelectItem > ) ) }
// </SelectContent > </Select > <FormMessage /> </FormItem > ) } />  <FormField
// control={ control } name="birthCondition" render={ ( { field } ) => ( <FormItem >
// <FormLabel >Birth Condition</FormLabel > <Select onValueChange={ field.onChange }
// defaultValue={ field.value } > <FormControl > <SelectTrigger > <SelectValue
// placeholder="Select birth condition" /> </SelectTrigger > </FormControl >
// <SelectContent className="max-h-[200px] overflow-y-auto z-50 shadow-lg bg-white"
// > { birthConditions.map ( ( option ) => ( <SelectItem key={ option.uid } value={
// option.uid } > { option.label } </SelectItem > ) ) } </SelectContent > </Select >
// <FormMessage /> </FormItem > ) } /> </div >  <div className="space-y-3" >
// <FormLabel >Vaccination</FormLabel > <div className="grid grid-cols-2
// md:grid-cols-3 gap-3" > { vaccineArray.map ( ( vaccine ) => ( <div key={
// vaccine.value } className="flex items-center space-x-2" > <Checkbox id={
// `vaccine-${ vaccine.value }` } checked={ currentVaccinations.includes (
// vaccine.value ) } onCheckedChange={ () => handleVaccinationChange ( vaccine.value
// ) } /> <label htmlFor={ `vaccine-${ vaccine.value }` } className="text-sm
// font-medium leading-none peer-disabled:cursor-not-allowed
// peer-disabled:opacity-70" > { vaccine.label } </label > </div > ) ) } </div >
// </div >  <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200
// dark:border-slate-700" > <p className="text-sm text-slate-600
// dark:text-slate-400" > Genetic information helps track breeding lineage and
// health management. Vaccination records are important for health monitoring and
// compliance with regulations. </p > </Card > </div > ) }

"use client";

import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  birthConditions,
  breedingTypes,
  paternalTypes,
  ratios,
  vaccineArray,
} from "@/utils/items.ts";

export function GeneticInfoForm() {
  const { control, setValue, watch } = useFormContext();
  const currentVaccinations = watch("vaccination") || [];

  console.log("Current Vaccinations:", currentVaccinations);

  const handleVaccinationChange = (value: string) => {
    if (currentVaccinations.includes(value)) {
      setValue(
        "vaccination",
        currentVaccinations.filter((v: string) => v !== value),
      );
    } else {
      setValue("vaccination", [...currentVaccinations, value]);
    }
  };

  const handleSelectAll = () => {
    setValue(
      "vaccination",
      vaccineArray.filter((v) => v.value !== "none").map((v) => v.value),
    );
  };

  const handleDeselectAll = () => {
    setValue("vaccination", []);
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-center mb-6">
        Genetic Information
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={control}
          name="paternalNucleus"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                Paternal Nucleus
              </FormLabel>
              <FormControl>
                <Input placeholder="Enter paternal nucleus" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="paternalType"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                Paternal Type
              </FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select paternal type" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent
                  className={"overflow-y-auto z-50 shadow-lg bg-white"}
                >
                  {paternalTypes.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="breedingType"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                Breeding Type
              </FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select breeding type" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent
                  className={"overflow-y-auto z-50 shadow-lg bg-white"}
                >
                  {breedingTypes.map((option) => (
                    <SelectItem key={option.name} value={option.name}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="racialComposition"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                Racial Composition
              </FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select racial composition" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent
                  className={"overflow-y-auto z-50 shadow-lg bg-white"}
                >
                  {ratios.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="birthCondition"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                Birth Condition
              </FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select birth condition" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent className="max-h-[200px] overflow-y-auto z-50 shadow-lg bg-white">
                  {birthConditions.map((option) => (
                    <SelectItem key={option.uid} value={option.uid}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <FormLabel className={"text-[#008c8fff]"}>Vaccination</FormLabel>
          <div className="flex gap-2">
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleSelectAll}
            >
              Select All
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleDeselectAll}
            >
              Deselect All
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {vaccineArray.map((vaccine) => (
            <div key={vaccine.value} className="flex items-center space-x-2">
              <Checkbox
                id={`vaccine-${vaccine.value}`}
                checked={currentVaccinations.includes(vaccine.value)}
                onCheckedChange={() => handleVaccinationChange(vaccine.value)}
              />
              <label
                htmlFor={`vaccine-${vaccine.value}`}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                {vaccine.label}
              </label>
            </div>
          ))}
        </div>
      </div>

      <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          Genetic information helps track breeding lineage and health
          management. Vaccination records are important for health monitoring
          and compliance with regulations.
        </p>
      </Card>
    </div>
  );
}
